import { Input, Button } from '@fashionnovateam/nova-ui-toolkit';
import React, { useState } from 'react';
import CustomModal from '../ReusableComponents/NewDesign/Modals/Modals';

export type TaxIdConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  value: string;
  onChangeValue: (value: string) => void;
  validateTIN: () => Promise<{ isValid: boolean }>;
};

export default function TaxIdConfirmationModal({
  open,
  onClose,
  onConfirm,
  value,
  onChangeValue,
  validateTIN,
}: TaxIdConfirmationModalProps) {
  const [taxModalError, setTaxModalError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    setLoading(true);
    if (!value || value.includes('*') || value.length !== 9) {
      setTaxModalError(
        'Tax ID is invalid, it must be 9 alphanumeric characters.',
      );
    } else {
      try {
        const res = await validateTIN();
        if (res.isValid) {
          setTaxModalError('');
          onConfirm();
        } else {
          setTaxModalError('Tax ID is invalid.');
        }
      } catch (err) {
        setTaxModalError('Tax ID is invalid.');
      }
    }
    setLoading(false);
  };

  if (!open) return null;

  return (
    <CustomModal open={open} handleClose={onClose}>
      <div className="twp mr-2 ml-2 mt-2 flex flex-col gap-2">
        <p className="font-semibold">
          Please confirm your Social Security Number or Tax ID
        </p>
        <Input
          maxLength={9}
          type="text"
          autoComplete="no"
          value={value}
          onChange={(e) => onChangeValue(e.target.value)}
          placeholder="Your Social Security Number or Tax ID"
          error={taxModalError !== ''}
        />
        {taxModalError !== '' && (
          <p className="text-danger-700">{taxModalError}</p>
        )}
        <div className="flex justify-end gap-2">
          <Button onClick={onClose}>Cancel</Button>
          <Button loading={loading} onClick={handleConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
